/* eslint-disable no-template-curly-in-string */
export default {
  core: {
    actions: {
      account: 'Account',
      cancel: 'Cancel',
      close: 'Close',
      dismiss: 'Dismiss',
      donate: 'Donate',
      edit: 'Edit',
      open: 'Open',
      remove: 'Remove',
      share: 'Share',
      signIn: 'Sign in',
      signOut: 'Sign out',
      sponsor: 'Sponsor',
      update: 'Update',
      sponsorAChild: 'Sponsor a child',
      donateToCause: 'Donate to a cause',
      submit: 'Submit',
      yes: 'Yes',
      no: 'No',
    },
    alert: {
      ariaLabel: 'Dismiss',
    },
    frequencies: {
      oneTime: 'One time',
      monthly: 'Monthly',
      annually: 'Yearly',
    },
    forms: {
      errors: {
        requiredField: 'This field is required',
        // eslint-disable-next-line no-template-curly-in-string
        amountLimits:
          'Please enter an amount between {{min, currency-custom}} and {{max, currency-custom}}',
        amountLimitsMax: 'Amount must be {{max, currency-custom}} or less',
        amountLimitsMin: 'Amount must be {{min, currency-custom}} or greater',
        invalidEmail: 'Invalid Email address',
        invalidZipCode: 'Zip code should be 12345 or 12345-1234',
        invalidPhone: 'Please enter a valid phone number',
        invalidPostalCodeMexico: 'Postal code should be 12345',
        invalidPostalCodeCanada: 'Postal code should be A1A 1A1',
        invalidDateFieldFormat: 'Date should be mm/dd/yyyy',
        invalidDateFieldValue: 'Please enter a valid date',
        firstAllowedDate:
          'This date must be at least {{minDaysOut}} days from today',
      },
    },
    fields: {
      phoneFieldError: 'Please enter a valid US phone number',
      date: {
        selectDate: 'Select a date',
      },
    },
    child: {
      imageAltPlaceholder: 'Photo of child',
    },
    chipGroup: {
      clear: 'Show {{name}} and clear other selections',
      show: 'Filter by {{name}}',
    },
    gallery: {
      seeMore: 'See More',
      next: 'Next Slide',
      prev: 'Previous Slide',
      title: 'Gallery: {{title}}',
      slide: {
        title: 'Slide {{index}} of {{length}}',
        altImage: 'gallery item {{index}} image',
        altThumbnail: 'gallery item {{index}} thumbnail',
      },
      open: 'Open media in lightbox',
    },
    glossary: { childSponsorship: 'Child Sponsorship' },
    slider: {
      minimum: 'Minimum',
      maximum: 'Maximum',
    },
    footer: {
      statement: "Releasing children from poverty in Jesus' name.",
      trustedOrg: "One of the world's highest-rated nonprofits",
      logoAlt: 'Compassion homepage',
      links: {
        privacy: {
          label: 'Privacy Statement',
        },
        conditions: {
          label: 'Conditions of Use',
        },
        disclosure: {
          label: 'Disclosure Statement',
        },
        sitemap: {
          label: 'Site Map',
        },
      },
      legal: `<p>Compassion International, Inc. is a registered 501(c)(3) nonprofit organization.Tax ID(EIN) 36-2423707</p>

      <p> Compassion®, Compassion International®, Compassion Sunday®, the Compassion Logo and the FILL THE STADIUM Logo are registered trademarks of Compassion International, Inc.</p>

      <p>All donations in the United States are tax deductible in full or part.</p>`,
      logoAlts: {
        guidestar: 'Guidestar Platinum Transparency',
        bbb: 'Better Business Bureau accredited charity',
        ecfa: 'ECFA Charter Member',
        charityWatch: 'Charity Watch Top-Rated',
      },
      copyrightLabel: 'Compassion International. All rights reserved.',
      strivingStatement: {
        label: 'Compassion strives to protect children from all forms of abuse',
      },
    },
    calendar: {
      previousButtonAriaLabel: 'Go to the previous month',
      nextButtonAriaLabel: 'Go to the next month',
      monthSelectAriaLabel: 'Choose the month',
      yearSelectAriaLabel: 'Choose the year',
    },
  },
  geo: {
    regions: {
      AF: 'Africa',
      AS: 'Asia',
      CA: 'Central America and Caribbean',
      SA: 'South America',
    },
    countries: {
      BD: {
        nameS: 'Bangladesh',
        nameM: 'Bangladesh, $t(geo.regions.AS)',
      },
      BF: {
        nameS: 'Burkina Faso',
        nameM: 'Burkina Faso, $t(geo.regions.AF)',
      },
      BO: {
        nameS: 'Bolivia',
        nameM: 'Bolivia, $t(geo.regions.SA)',
      },
      BR: {
        nameS: 'Brazil',
        nameM: 'Brazil, $t(geo.regions.SA)',
      },
      CO: {
        nameS: 'Colombia',
        nameM: 'Colombia, $t(geo.regions.SA)',
      },
      DO: {
        nameS: 'Dominican Republic',
        nameM: 'Dominican Republic, $t(geo.regions.CA)',
      },
      EC: {
        nameS: 'Ecuador',
        nameM: 'Ecuador, $t(geo.regions.SA)',
      },
      ET: {
        nameS: 'Ethiopia',
        nameM: 'Ethiopia, $t(geo.regions.AF)',
      },
      GH: {
        nameS: 'Ghana',
        nameM: 'Ghana, $t(geo.regions.AF)',
      },
      GT: {
        nameS: 'Guatemala',
        nameM: 'Guatemala, $t(geo.regions.CA)',
      },
      HN: {
        nameS: 'Honduras',
        nameM: 'Honduras, $t(geo.regions.CA)',
      },
      HT: {
        nameS: 'Haiti',
        nameM: 'Haiti, $t(geo.regions.CA)',
      },
      ID: {
        nameS: 'Indonesia',
        nameM: 'Indonesia, $t(geo.regions.AS)',
      },
      KE: {
        nameS: 'Kenya',
        nameM: 'Kenya, $t(geo.regions.AF)',
      },
      KH: {
        nameS: 'Cambodia',
        nameM: 'Cambodia, $t(geo.regions.AS)',
      },
      LK: {
        nameS: 'Sri Lanka',
        nameM: 'Sri Lanka, $t(geo.regions.AS)',
      },
      MM: {
        nameS: 'Myanmar',
        nameM: 'Myanmar, $t(geo.regions.AS)',
      },
      MW: {
        nameS: 'Malawi',
        nameM: 'Malawi, $t(geo.regions.AF)',
      },
      MX: {
        nameS: 'Mexico',
        nameM: 'Mexico, $t(geo.regions.CA)',
      },
      NI: {
        nameS: 'Nicaragua',
        nameM: 'Nicaragua, $t(geo.regions.CA)',
      },
      PE: {
        nameS: 'Peru',
        nameM: 'Peru, $t(geo.regions.SA)',
      },
      PH: {
        nameS: 'Philippines',
        nameM: 'Philippines, $t(geo.regions.AS)',
      },
      RW: {
        nameS: 'Rwanda',
        nameM: 'Rwanda, $t(geo.regions.AF)',
      },
      SV: {
        nameS: 'El Salvador',
        nameM: 'El Salvador, $t(geo.regions.CA)',
      },
      TH: {
        nameS: 'Thailand',
        nameM: 'Thailand, $t(geo.regions.AS)',
      },
      TZ: {
        nameS: 'Tanzania',
        nameM: 'Tanzania, $t(geo.regions.AF)',
      },
      TG: {
        nameS: 'Togo',
        nameM: 'Togo, $t(geo.regions.AF)',
      },
      UG: {
        nameS: 'Uganda',
        nameM: 'Uganda, $t(geo.regions.AF)',
      },
      ZM: {
        nameS: 'Zambia',
        nameM: 'Zambia, $t(geo.regions.AF)',
      },
    },
    seo: {
      countries: {
        bangladesh: {
          name: 'Bangladesh',
          seoTitle: 'Stories from Bangladesh',
          seoDescription:
            'Discover inspiring stories from Compassion’s work in Bangladesh.',
        },
        bolivia: {
          name: 'Bolivia',
          seoTitle: 'Stories from Bolivia',
          seoDescription:
            'Explore how Compassion is changing lives in Bolivia.',
        },
        brazil: {
          name: 'Brazil',
          seoTitle: 'Stories from Brazil',
          seoDescription:
            'Read powerful stories of hope and transformation in Brazil.',
        },
        burkinaFaso: {
          name: 'Burkina Faso',
          seoTitle: 'Stories from Burkina Faso',
          seoDescription:
            'See how Compassion supports children and families in Burkina Faso.',
        },
        cambodia: {
          name: 'Cambodia',
          seoTitle: 'Stories from Cambodia',
          seoDescription:
            'Learn how Compassion is making a difference in Cambodia.',
        },
        colombia: {
          name: 'Colombia',
          seoTitle: 'Stories from Colombia',
          seoDescription: 'Discover stories of impact and faith from Colombia.',
        },
        dominicanRepublic: {
          name: 'Dominican Republic',
          seoTitle: 'Stories from the Dominican Republic',
          seoDescription:
            'Explore how Compassion is helping children thrive in the Dominican Republic.',
        },
        ecuador: {
          name: 'Ecuador',
          seoTitle: 'Stories from Ecuador',
          seoDescription:
            'Read stories of hope and change from Compassion’s work in Ecuador.',
        },
        elSalvador: {
          name: 'El Salvador',
          seoTitle: 'Stories from El Salvador',
          seoDescription:
            'Discover how Compassion is transforming lives in El Salvador.',
        },
        ethiopia: {
          name: 'Ethiopia',
          seoTitle: 'Stories from Ethiopia',
          seoDescription:
            'Explore stories of resilience and faith from Ethiopia.',
        },
        ghana: {
          name: 'Ghana',
          seoTitle: 'Stories from Ghana',
          seoDescription:
            'Learn how Compassion is empowering children in Ghana.',
        },
        guatemala: {
          name: 'Guatemala',
          seoTitle: 'Stories from Guatemala',
          seoDescription:
            'Discover inspiring stories from Compassion’s work in Guatemala.',
        },
        haiti: {
          name: 'Haiti',
          seoTitle: 'Stories from Haiti',
          seoDescription:
            'See how Compassion is bringing hope to children in Haiti.',
        },
        honduras: {
          name: 'Honduras',
          seoTitle: 'Stories from Honduras',
          seoDescription: 'Explore stories of transformation from Honduras.',
        },
        indonesia: {
          name: 'Indonesia',
          seoTitle: 'Stories from Indonesia',
          seoDescription: 'Read how Compassion is changing lives in Indonesia.',
        },
        kenya: {
          name: 'Kenya',
          seoTitle: 'Stories from Kenya',
          seoDescription: 'Discover stories of hope and growth from Kenya.',
        },
        sriLanka: {
          name: 'Sri Lanka',
          seoTitle: 'Stories from Sri Lanka',
          seoDescription:
            'Learn how Compassion supports children in Sri Lanka.',
        },
        malawi: {
          name: 'Malawi',
          seoTitle: 'Stories from Malawi',
          seoDescription:
            'Learn how Compassion supports children and families in Malawi.',
        },
        mexico: {
          name: 'Mexico',
          seoTitle: 'Stories from Mexico',
          seoDescription: 'Explore stories of impact and faith from Mexico.',
        },
        myanmar: {
          name: 'Myanmar',
          seoTitle: 'Stories from Myanmar',
          seoDescription:
            'Discover how Compassion is helping children thrive in Myanmar.',
        },
        nicaragua: {
          name: 'Nicaragua',
          seoTitle: 'Stories from Nicaragua',
          seoDescription:
            'Read stories of transformation from Compassion’s work in Nicaragua.',
        },
        peru: {
          name: 'Peru',
          seoTitle: 'Stories from Peru',
          seoDescription: 'See how Compassion is changing lives in Peru.',
        },
        philippines: {
          name: 'Philippines',
          seoTitle: 'Stories from Philippines',
          seoDescription:
            'Discover stories of hope and faith from the Philippines.',
        },
        rwanda: {
          name: 'Rwanda',
          seoTitle: 'Stories from Rwanda',
          seoDescription:
            'Explore how Compassion is making a difference in Rwanda.',
        },
        tanzania: {
          name: 'Tanzania',
          seoTitle: 'Stories from Tanzania',
          seoDescription:
            'Discover inspiring stories from Compassion’s work in Tanzania.',
        },
        thailand: {
          name: 'Thailand',
          seoTitle: 'Stories from Thailand',
          seoDescription:
            'Read stories of transformation and hope from Thailand.',
        },
        togo: {
          name: 'Togo',
          seoTitle: 'Stories from Togo',
          seoDescription:
            'See how Compassion is helping children thrive in Togo.',
        },
        uganda: {
          name: 'Uganda',
          seoTitle: 'Stories from Uganda',
          seoDescription: 'Explore stories of impact and growth from Uganda.',
        },
        zambia: {
          name: 'Zambia',
          seoTitle: 'Stories from Zambia',
          seoDescription:
            'Discover how Compassion is changing lives in Zambia.',
        },
      },
    },
  },
  contact: {
    phonePrimary: '800-336-7676',
    assistanceMessage:
      'If you need assistance, please call <anchor className="link" href="tel:$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>.',
    emailGiftPlanning: 'giftplanning@compassion.com',
    emailMajorGifts: 'wisegiving@compassion.com',
  },
  checkout: {
    skipLink: 'Skip to content',
    nav: {
      steps: {
        1: 'Summary',
        2: 'Review & Submit',
      },
      goToMyAccount: 'Go to My Account',
    },
    child: {
      microcopy: {
        firstDonation: 'First donation for {{name}}',
        commitmentPayment: 'Commitment Payment for {{name}}',
        gift: 'Gift for {{name}}',
        giftCenter: 'Center Gift for {{name}}',
        giftBirthday: 'Birthday Gift for {{name}}',
        giftFamily: 'Family Gift for {{name}}',
        giftFamilyCta: "Help support {{name}}'s family.",
        longestWaiting: 'Longest Waiting',
        singleChildSelected: '1 Child Selected for You',
        singleChildWaiting:
          'Please choose a child who has been waiting the longest for help.',
        multiChildrenSelected: '{{qty, number}} Children Selected for You',
        multiChildrenWaiting:
          'Please choose {{qty, number}} children who have been waiting the longest for help.',
        waiting: 'Waiting {{numDays, number}} days',
        waiting_verbose:
          '{{name}} has been waiting {{numDays, number}} days for a sponsor.',
      },
      criteria: {
        criterion_gender:
          '$t(checkout.child.criteria.criterion_gender_{{gender}})',
        criterion_gender_Female: '<strong>Gender:</strong> Girl',
        criterion_gender_Male: '<strong>Gender:</strong> Boy',
        criterion_age: '<strong>Age Range:</strong> {{ageMin}}-{{ageMax}}',
        criterion_countries:
          '<strong>Country:</strong> {{countries}}, {{region}}',
        criterion_region: '<strong>Region:</strong> {{region}}',
        criterion_isOrphan: '<strong>Orphaned Child:</strong> Yes',
        criterion_disability: '<strong>With Disability:</strong> Yes',
        criterion_isInHivAffectedArea:
          '<strong>Affected by HIV/AIDS:</strong> Yes',
      },
    },
    currency: {
      usd: '{{amount, currency-custom}}',
      usd_Monthly: '{{amount, currency-custom}}/mo',
      usd_Quarterly: '{{amount, currency-custom}}/qtr',
      usd_Semianually: '{{amount, currency-custom}}/6mo',
      usd_Annually: '{{amount, currency-custom}}/yr',
      free: 'Free!',
    },
    donationSummary: {
      donationSummary: 'Donation summary',
      dueToday: 'Due today',
      reviewDonation: 'Review donation',
      yourDonation: 'Your donation',
    },
    cartPremium: {
      acceptPrompt: 'Yes, please send my free gift',
      moreDetails: 'More details',
      requirements: {
        message:
          'This gift is only available for those with US shipping addresses.',
        title: 'Sorry, you are not eligible for this free gift',
      },
    },
    totals: {
      today: 'Total Today',
      monthly: 'Total Monthly',
      yearly: 'Total Yearly',
    },
    disclaimer: {
      cdspSubsidized:
        'Through the generous gifts of our donors, we can now offer a lower rate of ${{subsidizedCdspRate}} per month for {{subsidizedDuration}} months of sponsorship. After {{subsidizedDuration}} months, your sponsorship rate will change to the then current rate. We’ll send you a digital reminder at least thirty days prior to that change.',
      recurring: `Recurring donations will be automatically charged using the payment method you provided, at the frequency selected, until you tell us to stop. If child sponsorship rates increase, you will be charged at our then-current rate. We will always notify you prior. You can cancel anytime to avoid future charges by calling <a class="link" href="tel: {{primaryPhone}}"}>{{primaryPhone}}</a>, Monday-Friday, 7 a.m. to 5:30 p.m. MT. Please allow three business days to process cancellation requests.`,
    },
    form: {
      ariaLbale: 'Checkout Form',
      addressFields: {
        mailingAddressLabel: 'Mailing address',
        addressNumberError: 'Invalid address',
        billingAddressLabel: 'Billing address',
        addressAdditionalLabel: 'Apt, suite, etc. (if applicable)',
        countryLabel: 'Country',
        countryPlaceholder: 'Select country',
        cityLabel: 'City',
        cityNumberError: 'Invalid city',
        stateLabel: 'State',
        statePlaceholder: 'Select state',
        provinceLabel: 'State/Province',
        provinceNumberError: 'Invalid state/province',
        zipCodeLabel: 'Zip code',
        postalCodeLabel: 'Postal code',
      },
      billingFields: {
        header: 'Billing information',
        cardNumberLabel: 'Card number',
        expirationDateLabel: 'Exp. date',
        expirationDatePlaceholder: 'MM/YY',
        securityCodeLabel: 'Security code',
        nameOnCardLabel: 'Name on card',
        nameOnCardError: 'Please enter a valid name',
        nameOnCardNumberError: 'Name on card only',
        matchAddressLabel: 'Billing address same as mailing address',
      },
      contactFields: {
        header: 'Contact information',
        signInLabel: ' for a faster checkout',
        firstNameLabel: 'First name',
        firstNameNumberError: 'Invalid first name',
        lastNameLabel: 'Last name',
        lastNameNumberError: 'Invalid last name',
        emailLabel: 'Email',
        phoneNumberLabel: 'Phone number',
        groupFields: {
          label:
            'A business, school, or other organization is funding this sponsorship or donation.',
          name: 'Group or business name',
          nameNumberErrpr: 'Group or business name only',
          groupTypeLabel: 'Group type',
          groupType: {
            business: 'Business',
            church: 'Church',
            organization: 'Organization',
            placeholder: 'Select group type',
            school: 'School',
          },
        },
      },
      continueToReview: 'Continue to Review',
      card: {
        codeInvalid: 'Please enter a valid security code',
        codeTooltip:
          '3-digit security code usually found on the back of your card. American Express cards have a 4-digit code located on the front.',
        expiryInvalid: 'Please enter a valid expiration date',
        numberInvalid: 'Please enter a valid credit card number',
      },
      ach: {
        nameInvalid: 'Please enter a valid name',
        accountInvalid: 'Please enter a valid account number',
        routingInvalid: 'Please enter a valid routing number',
        accountRoutingMatch: 'Routing Number and Account Number must not match',
        accountNumber: 'Cannot be credit card number',
      },
      expressCheckout: 'Express Checkout',
      yourInformation: 'Your information',
      submitTransaction: 'Submit',
    },
    review: {
      edit: 'Edit',
      billing: {
        cardWarning: `We're sorry, we're having an issue communicating with our secure payment provider. Please continue to submit and our supporter care team will contact you within 1-2 business days to finalize your payment information.`,
        cardType: 'Card Type',
        cardNumber: 'Card Number',
        cardOwnerName: 'Name on Card',
        paymentType: 'Payment Method',
        paymentDay: 'Payment Day',
        address: 'Billing Address',
        matchingAddress: 'Same as mailing address',
      },
      contact: {
        name: 'Name or Preferred Contact',
        address: 'Mailing Address',
        email: 'Email',
        phone: 'Phone',
        groupType: 'Group Type',
        groupName: 'Group Name',
      },
      ofTheMonth: 'of the month',
    },
    dialogEdit: {
      customAmount: 'Custom Amount',
      donationTitle: 'Edit donation amount',
      donationUpdate: 'Update Donation',
      donationContentAriaLabel: 'update donation amount',
      donationFrequencyAriaLabel: 'select payment frequency',
      donationFieldAriaLabel: 'custom donation amount',
      giftContentAriaLabel: 'update gift amount',
      giftFieldAriaLabel: 'custom gift amount',
      giftTitle: 'Edit gift amount',
      giftUpdate: 'Update Gift',
      paymentContentAriaLabel: 'update payment amount',
      paymentFieldAriaLabel: 'custom payment amount',
      paymentTitle: 'Edit payment amount',
      paymentUpdate: 'Update Payment',
    },
    paymentOptions: {
      ach: {
        label: 'Checking Account',
      },
      paypal: {
        label: 'PayPal',
      },
      applePay: {
        label: 'Apple Pay',
        postalCode: {
          generalError: 'Please enter a zipcode',
          USError: 'Zip code should be 12345 or 12345-1234.',
          MXError: 'Postal code should be 12345.',
          CAError: 'Postal code should be A1A 1A1.',
        },
        name: {
          firstNameError: 'Given name is required',
          lastNameError: 'Family name is required',
        },
        monthlyCommitments: 'Monthly commitments',
        yearlyCommitments: 'Yearly Commitments',
      },
      creditCard: {
        label: 'Credit Card',
      },
    },
    dialogEditQuantity: {
      title: 'How many children would you like to sponsor?',
      contentAriaLabel: 'update donation quantity',
    },
    complete: {
      thankYouTitle: 'Thank you for making a difference!',
      contributionsInformation:
        'Your contributions were made successfully. An email will be sent to you shortly with a summary of your contribution. Click the button below to log in or create your account. Please note that this contribution could take up to 24 hours to show in your Giving History.',
      downloadOurApp: 'Download our app',
      mainCTA: 'My Account',
      commitmentPaymentMessage:
        'Your payment succeeded, but it may take up to 24 hours to appear in your account.',
    },
    nextSteps: {
      title: 'Next Steps',
      step1: {
        title: 'Get the MyCompassion app',
        body: `Stay connected with your sponsored child's world. Write to them anytime, anywhere.`,
        buttonCta: 'Learn more',
      },
      step2: {
        title: 'Connect and share',
        body: 'Keep up with us through social media and share Compassion with your family and friends.',
        facebook: 'Facebook',
        instagram: 'Instagram',
      },
      step3: {
        title: 'Pray with us',
        body: 'When children are faced with the challenges posed by poverty, prayer is their lifeline.',
        buttonCta: 'Learn more',
      },
      step4: {
        title: 'Match Your Gift!',
        body: 'Many companies match gifts made by their employees to Compassion. Find out if your company matches.',
        buttonCta: 'Company Lookup',
      },
    },
    emptyCart: {
      emptyBasketTitle: 'Your basket is empty!',
      emptyBasketSubTitle:
        'Help a child today by sponsoring or sending a gift to fulfill a critical need.',
    },
    upsells: {
      actions: {
        addChildSponsorship: 'Add sponsorship',
        addDonation: 'Add donation',
        noThankYou: 'No, thank you',
      },
      upsellSponsorshipTitle: 'Consider Sponsoring This Child',
      upsellFundTitle: 'Consider Sponsoring Where Most Needed',
      upsellSponsorshipSubtitle:
        "You can change a child's life from one of hardship and loneliness to one of hope and meaning. Sponsor a child and bring the love of Christ to a child in need.",
      upsellFundSubtitle: 'Monthly donation to support children in urgent need',
    },
    artists: {
      review: 'Two',
      complete: 'Your two',
      concertDetailsLabel: 'Concert details:',
      concertTitleTickets: '$t(checkout.artists.{{stage}}) free tickets',
      concertTitleMeetGreet:
        '$t(checkout.artists.{{stage}}) free meet and greet passes',
      concertTitleMeetGreetTickets:
        '$t(checkout.artists.{{stage}}) free tickets and meet and greet passes',
      concertTitleQA:
        '$t(checkout.artists.{{stage}}) free exclusive pre-show Q&A passes',
      concertTitleQATickets:
        '$t(checkout.artists.{{stage}}) free tickets and exclusive pre-show Q&A passes',
      eventDetails: '{{date}} • {{venue}}',
      taxMessage:
        'All donations in the United States are tax-deductible in full or part. This offer is available only to residents of the United States who sponsor a child online and agree to sign up for the convenience of automatic payments. Please sponsor a child today to receive your tickets. Donation is tax deductible less the average Fair Market Value ($120.00) of the tickets. Limited quantities available while supplies last.',
      ticketProcessing: 'Processing...',
      ticketSuccess:
        'Congratulations! Your confirmation email is being delivered to your inbox at this very moment. Please check your email for it. If it has not arrived in 24 hours, please check your spam folder.',
      ticketError: 'Your ticket(s) could not be processed.',
    },
    addOns: {
      name: 'Disaster Relief',
      description: '${{amount}} per month for Disaster Relief',
      information:
        'Help other children experiencing crisis, trauma or emergency when they need it most. Give ${{amount}} a month to the Disaster Relief fund',
    },
    honorCards: {
      title: "Don't forget your honor cards!",
      description:
        'Choose from a variety of greeting cards for any occasion and select how you’d like to send/receive them.',
      button: 'Select Your Honor Cards',
      titleReview: 'Honor Cards',
      descriptionReview: 'Details filled out after checkout',
      titleComplete: 'Honor Cards',
      descriptionComplete: 'Fill out details now',
    },
    errors: {
      ACH_VALIDATION: {
        message: `We are unable to validate your payment information at this time. Please use a different payment method or try again later.`,
      },
      AM_ERROR: {
        message: `We're sorry, we had a communication problem securing a child for you. Please try again. $t(contact.assistanceMessage)`,
      },
      AM_HOLD: {
        message: `We're sorry! We were unable to secure a child for you. Please try again. $t(contact.assistanceMessage)`,
      },
      APPLE_PAY_AUTHORIZATION: {
        message: `There was a problem charging your Apple Pay credit card. Please edit your payment information or try a different payment method.`,
      },
      CARD_AUTHORIZATION: {
        message: `There was a problem processing your credit card. Please edit your payment information or try a different payment method.`,
      },
      CARD_AUTHORIZATION_EXISTING: {
        message: `There was a problem processing your credit card. Please try a different payment method or <linkEditBilling>edit your payment information</linkEditBilling>.`,
      },
      CARD_ENCRYPTION: {
        message: 'We were unable to securely store your payment details.',
      },
      CARD_TOKENIZATION: {
        message:
          'There was a problem communicating with our secure payment provider. Please try again later.',
      },
      CART_CONFLICT: {
        title: 'Cart conflict detected',
        message:
          'It appears that you were sharing a cart with another user. Unfortunately, this has resulted in the loss of the items in your cart. We apologize for the inconvenience.',
      },
      CART_EMPTY: {
        message: `We're sorry, but it seems that your cart is currently empty. Please add an item to your cart and try again.`,
      },
      CART_ERROR: {
        message: '$t(checkout.errors.GENERIC_FUND.message)',
      },
      CART_GENERIC: {
        message:
          'We apologize, an error with your cart has occurred. Please try again. $t(contact.assistanceMessage)',
      },
      CART_MERGE_LOSS: {
        title: 'Cart items removed',
        message: `We're sorry! We had to remove the children in your cart as we detected an unusual situation where they were in another user's cart as well. $t(contact.assistanceMessage)`,
      },
      CART_MAX: {
        title:
          'Your cart total is over the {{ maxLimit, currency-custom }} limit.',
        message:
          'To continue, please reduce the amount(s) or reach out to us at <anchor className="link" href="mailto:$t(contact.emailGiftPlanning)">$t(contact.emailGiftPlanning)</anchor> to make a major gift.',
      },
      CHILD_NOT_FOUND: {
        message: `We're sorry! The child/children that you were trying to sponsor cannot be added to your cart. $t(contact.assistanceMessage)`,
      },
      CHILD_NOT_FOUND_MULTI: {
        message: `We're sorry! There are no children matching the criteria that you provided. $t(contact.assistanceMessage)`,
      },
      ENCRYPTION_ERROR: {
        message: `We were unable to securely store your payment details.`,
      },
      GENERIC_FUND: {
        message: `$t(checkout.errors.ITEMS_ADD.message)'`,
      },
      GENERIC_SCHEMA: {
        message: `We're sorry, an error has occurred. Please try again. $t(contact.assistanceMessage)`,
      },
      GIFT_CONFLICT_BIRTHDAY: {
        message: `You have given a child gift to {{childName}} this year and have a second in the cart already. If you would like to send a birthday gift instead, you will first need to remove the child gift.`,
      },
      GIFT_CONFLICT_CHILD: {
        message: `You are choosing to give a birthday gift to {{childName}} which counts as a second child gift for this year. Thank you!`,
      },
      GIFT_UNAVAIL: {
        message: `We're sorry, you have already given the maximum number/amount of {{giftType}} gifts to {{childName}}. Thank you!`,
      },
      // TODO :: create `LOST_HOLD` error in other translations.
      HOLD_FAILED: {
        // title:
        //   'Thank you! But this child has just been sponsored by someone else!',
        // message: `We're sorry! {{childName}} is unable to be sponsored at this time. You may try again or you can make a difference in another child's life. <anchor className="link" href="{{domain}}/sponsor_a_child/">View more</anchor> children living in poverty who need you.`,
        // TODO: HOLD_FAILED uses don't seem to supply the child name... This seems mostly related to the fact it's also used for returning errors from proxy-api...
        message: `We're sorry! We were unable to add {{childName}} to your cart. Please try again. $t(contact.assistanceMessage)`,
      },
      HOLD_MULTI_FAILED: {
        message: `We're sorry! We were unable to add the children you requested. Please try again. $t(contact.assistanceMessage)`,
      },
      HOLD_LOST: {
        title:
          'Thank you! But this child has just been sponsored by someone else!',
        // Legacy message: We're sorry. {0} been removed from your cart because someone else has possibly sponsored {1}. They were likely selected by another person while you were considering your sponsorship on the website. <br /> <br /> <a href=\"/sponsor_a_child/\">View other children</a> who are waiting for a sponsor.
        message: `We're glad that {{childName}}'s life is about to change, but we're sad that it wasn't by you. You can make a difference in another child's life. <anchor className="link" href="{{domain}}/sponsor_a_child/">View more</anchor> children living in poverty who need you.`,
      },
      HOLD_SPONSORED: {
        title:
          'Thank you! But this child has just been sponsored by someone else!',
        message: `We're glad that {{childName}}'s life is about to change, but we're sad that it wasn't by you. You can make a difference in another child's life. <anchor className="link" href="{{domain}}/sponsor_a_child/">View more</anchor> children living in poverty who need you.`,
      },
      HOLD_SPONSORED_UPSELL: {
        title:
          'Thank you! But this child has just been sponsored by someone else!',
        message: `We're glad that {{childName}}'s life is about to change, but we're sad that it wasn't by you. Great news though! We found another child living in poverty who needs you.`,
      },
      INACTIVE_FUND: {
        message: `We're sorry! It looks like you've tried to donate to a fund that is no longer active or has been changed. Would you like to <anchor className="link" href="{{domain}}/ways-to-donate.htm">select a different fund</anchor> to donate to?`,
      },
      ITEM_FREQ: {
        // message: `We're sorry! It looks like you've tried to add a fund with an invalid commitment frequency. Would you like to <anchor className="link" href="{{domain}}/ways-to-donate.htm">select a different fund</anchor> to donate to?`,
        message: '$t(checkout.errors.GENERIC_FUND.message)',
      },
      ITEM_MAX: {
        title:
          'Your donation exceeds the {{ maxLimit, currency-custom }} limit.',
        message:
          'To continue, please reduce the amount or reach out to us at <anchor className="link" href="mailto:$t(contact.emailGiftPlanning)">$t(contact.emailGiftPlanning)</anchor> to make a major gift.',
      },
      ITEM_MIN: {
        title:
          'Your donation does not meet the {{ minLimit, currency-custom }} minimum.',
        message: 'To continue, please increase the amount and try again.',
      },
      ITEM_RANGE: {
        message:
          'The {{ amount, currency-custom }} amount that you attempted to add/update is not within the allowed range of {{ min, currency-custom }} and {{ max, currency-custom }}. Please change the amount and try again.',
      },
      ITEMS_ADD: {
        message: `We're sorry! We were unable to add the item(s) to your cart. Please try again. $t(contact.assistanceMessage)`,
      },
      PAYPAL_TRANSACTION_FAIL: {
        message: `There was a problem charging your PayPal payment method. Please edit your payment information or try a different payment method.`,
      },
      SESSION_EXPIRED: {
        message: `We're sorry! Your session has expired. Please confirm or update your information and try again. $t(contact.assistanceMessage)`,
      },
      SESSION_EXPIRED_AUTH: {
        title: `$t(checkout.errors.USER_EXPIRED.title)`,
        message: `$t(checkout.errors.USER_EXPIRED.message)`,
      },
      TRANSACTION_COMPLETE: {
        message: `It looks like a transaction has already been completed for this cart; perhaps in a different window. $t(contact.assistanceMessage)`,
      },
      TRANSACTION_CART_VERSION_FAIL: {
        message:
          'We apologize for the inconvenience, but we detected your cart was updated in another window. Please review the changes to ensure everything is correct and resubmit. Thank you for your understanding.',
      },
      TRANSACTION_AUTH_CONFLICT: {
        message:
          'We apologize for the inconvenience, but we detected your information was possibly updated in another window. Please review the changes to ensure everything is correct and resubmit. Thank you for your understanding.',
      },
      TRANSACTION_GENERIC: {
        message: `We're sorry! We were unable to process your transaction. Please review your information and try again. If you need assistance, please call <anchor className="link" href="tel:$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>`,
      },
      TRANSACTION_NO_CART: {
        message: '$t(checkout.errors.CART_EMPTY.message)',
      },
      TRANSACTION_NO_USER: {
        // message: `We're sorry! Your session has expired. Please confirm or update your information and try again. $t(contact.assistanceMessage)`,
        message: `$t(checkout.errors.USER_EXPIRED.message)`,
      },
      TRANSACTION_PAYMENT_FAIL: {
        message: '$t(checkout.errors.CARD_AUTHORIZATION.message)',
      },
      USER_EXPIRED: {
        title: `You've been logged out!`,
        message: `We're sorry! Your session has expired. Please log in or update your information to check out as a guest and try again. $t(contact.assistanceMessage)`,
      },
      USER_FETCH: {
        message: `We're sorry! We encountered a problem when loading the page. Please try refreshing your browser or proceed to enter your information to see if things clear up. If you need assistance, please call <anchor className="link" href="$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>`,
      },
      USER_FETCH_SCHEMA: {
        message: `We're sorry! It appears that some of your information is invalid. Please review and make any necessary changes. If you need assistance, please call <anchor className="link" href="$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>`,
      },
      USER_PAYMENT_METHODS_SCHEMA: {
        message: `We're sorry! We were unable to load your payment methods. Please try again. If you need assistance, please call <anchor className="link" href="tel:$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>`,
      },
      USER_SAVE: {
        message: `We're sorry! We were unable to save your information. Please review and try again. If you need assistance, please call <anchor className="link" href="tel:$t(contact.phonePrimary)">$t(contact.phonePrimary)</anchor>`,
      },
    },
    redirect: {
      cachedMessage:
        'Use the button below to <strong>join the Live Celebration Experience with {{experience}}</strong>.',
      eventFallback: 'your event',
      redirectCTA: 'Go there now',
      redirecting: 'Redirecting...',
      redirectMessage: `You'll be automatically redirected to <strong>join the Live Celebration Experience with {{experience}}</strong> in {{time}} seconds.`,
      stopCTA: 'Stop Redirect',
      stoppedMessage:
        'Automatic redirect has been stopped. Use the button below to <strong>join the Live Celebration Experience with {{experience}}</strong>.',
    },
  },
  login: {
    form: {
      header: 'Sign in',
      usernameLabel: 'Username',
      passwordLabel: 'Password',
      forgotPassword: 'Forgot Password?',
      submit: 'Sign in',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },
  },
  paymentMethods: {
    ach: {
      add: 'Add a checking account',
      label: 'Checking Account',
      fields: {
        account: 'Checking account number',
        label: 'Checking account fields',
        name: 'Name on checking account',
        routing: 'Bank routing number',
      },
      description: 'Where do I find this information?',
      information: {
        checking: {
          label: 'Checking',
          body: 'Your personal bank account number. This is found next to the routing number on your checks.',
        },
        routing: {
          label: 'Routing',
          body: 'A 9-digit number that identifies your bank. You can find it on the bottom left of your checks.',
        },
      },
    },
    paypal: {
      add: 'One time payments',
      description:
        'In the next step, you will review your information and then continue with PayPal.',
    },
    apple: {
      description:
        'In the next step, you will review your information and then continue with Apple Pay.',
    },
    creditCard: {
      add: 'Add a credit card',
      fieldLabel: 'Credit card fields',
      savedAddress: 'Select a saved address',
    },
    addNewAddress: 'Add new address',
    endingIn: 'Ending in',
    expires: 'Expires',
  },
  // TODO add translations to es, ko
  auth: {
    box: {
      heading: {
        create: 'Create Account',
        login: 'Log in',
        loginSuccess: 'Log in successful!',
        password: 'Reset your password',
        success: 'Your information has been updated!',
        thanks: 'Thank you!',
        validate: 'Validate your email address',
        username: 'Recover your username',
      },
      description: {
        code: "We've sent a 6-digit verification code to {{email}}",
        createEmail: '1. Enter your email or Sponsor Donor Number',
        createUsernameAndPassword: '2. Choose a Username and Password',
        login: 'Log in with your Compassion account.',
        more: 'We need one more piece of information in order to reset your password.',
        moreUsername:
          'We need one more piece of information in order to send your username.',
        or: 'or',
        email:
          'Please enter the email associated with your account.  If the email you submitted is connected to an account, you will receive a validation code.',
        username:
          'Please enter the email associated with your account.  If the email you submitted is connected to an account, you will receive a username reminder.',
        redirect: "You'll be automatically redirected to {{redirect}}.",
        forgotValidation1:
          '1. Enter the 6-digit validation code you received in your email.',
        forgotValidation2: '2. Update or keep your information the same.',
        validationCode:
          'If you have not received a validation code within approximately 5 minutes, we were unable to locate your record using the information you provided.',
      },
      footer: {
        help: {
          haveAccount: 'Already have an account? Sign in.',
          password: 'Forgot your password?',
          return: 'Return to login',
          username: 'Forgot your username?',
        },
      },
      form: {
        code: 'One time code',
        email: 'Email',
        emailPlaceholder: 'jane.doe@gmail.com',
        password: 'Password',
        sponsorNumber: 'Sponsor/Donor number',
        sponsorNumberPlaceholder: 'Example: 01637017',
        username: 'Username',
        usernamePlaceholder: 'Example: JaneDoe123',
        zipCode: 'Zip code',
        caseSensitiveHint: '(Case sensitive)',
        button: {
          continue: 'Continue',
          create: 'Create my account',
          recover: 'Recover username',
          reset: 'Reset password',
          return: 'Return to {{name}}',
          submit: 'Submit',
          update: 'Update your information',
        },
        link: {
          create: 'Create an account',
        },
        tooltip: {
          email:
            'When you create an account using your email address, we will send you a unique code. You will need this code to verify your address and complete your account.',
          sponsorNumber:
            'Your Sponsor or Donor number is at the bottom of most Compassion emails, and for new sponsors, you can also find it on your welcome packet.',
        },
        placeholder: {
          code: 'Example: {{code}}',
        },
        validation: {
          number: 'Contains at least 1 number',
          special: 'Contains at least 1 special character',
          uppercase: 'Contains at least 1 uppercase letter',
          lowercase: 'Contains at least 1 lowercase letter',
          length: 'Contains at least 8 characters',
        },
      },
    },
    alerts: {
      alreadyLoggedIn: `<p>You are already logged in. You can return to <ReturnLink />.</p>
          <p>Or, if you wish to login with a different account, use the form below.</p>`,
      createSuccessful: {
        title: 'Account verified and created successfully!',
        message: 'You are now logged in and ready to go.',
      },
      emailConfirmedSuccessful: {
        title: 'We have verified your email address.',
        message: 'Please login below',
      },
      userNotConfirmed:
        'Our records show that you have not verified the email address used to create your web account. <ResendLink /> to the preferred email address listed on your account.',
      resendValidationLink: 'resend the validation code',
      resetPasswordLink: 'reset your password',
      recoverUsernameLink: 'recover your username',
      loginLink: 'login',
      loginLinkCapitalized: 'Login',
      userStatusNotResolvable:
        'Please verify your information. If what you have is correct, your username no longer meets requirements and needs to be changed. Please call us at <CallCenterNumber />',
      userSupporterNotFound:
        'Your account requires attention. Please call us at <CallCenterNumber /> to speak with a Compassion representative.',
      passwordResetRequired:
        'Your password requires a reset. Please <ResetLink /> or call us at <CallCenterNumber />, to speak with a Compassion representative.',
      tooManyAttempts: 'Too many attempts. Please try again later.',
      unknownError: 'Please verify your information and try again.', // Needs buisiness approval
      internalError:
        'We are currently having technical difficulties. Please try again in a few minutes.', // Needs buisiness approval
      multipleAccountsFound: 'We need more information',
      emailVerificationRequired:
        "We're sorry, it appears that the information you provided is not adequate enough to uniquely identify you. Please call us at <CallCenterNumber />",
      invalidPassword:
        'Please provide a password that meets the password requirements: minimum 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.',
      invalidUsername:
        'Please verify your information. If what you have is correct, your username no longer meets requirements and needs to be changed. Please call us at <CallCenterNumber />, to speak with a Compassion representative.',
      usernameAlreadyInUse:
        'The Username you entered is already in use. Please choose another.',
      webAccountAlreadyExists:
        'That Sponsor/Donor number already has a web account. Go to the <LoginLink />. Did you forget your <RecoverUsernameLink /> or <ForgotPasswordLink />',
      webAccountByEmailAlreadyExists:
        'The email address used is associated with an existing web account. <LoginLink /> or <RecoverUsernameLink /> or <ForgotPasswordLink />.',
      invalidCode: 'The validation code you entered is invalid.',
      expiredCode:
        'The validation code you provided is not valid. Please verify the code or <ResendLink /> if the code has already been used or is expired.',
      createForm: {
        resetPasswordLink: 'password',
        recoverUsernameLink: 'username',
        multipleAccountsFoundEmail:
          'In order to identify you and your commitments to Compassion more specifically, please enter your sponsor/donor number.', // Needs buisiness recheck
        multipleAccountsFoundGlobalId:
          'In order to identify you and your commitments to Compassion more specifically, please review the information you provided and try again', // Needs buisiness approval
        noMatch:
          "<p><strong>We were unable to locate your record using the information you provided.</strong></p><p>If you recently donated to {{appName}} we might still be processing your donation.</p><p>Please try again once you've received your welcome e-mail with your supporter ID.</p>",
      },
      createValidationForm: {
        account_already_confirmed:
          "The validation code cannot be confirmed, it's possible your account is already validated. Links can only be used once and the validation code expires after 24 hours. <br /> We recommend trying one of the following: <LoginLink /> to continue,  <br />  <RecoverUsernameLink />, <br /> or <ForgotPasswordLink />",
      },
      loginForm: {
        notAuthorized:
          'Your username and password did not match. Please try again or <ResetLink />.',
      },
      forgotForm: {
        missingEmail: 'Please supply an email address.',
      },
    },
    header: {
      logoAlt: 'Compassion homepage',
    },
    footer: {
      description: {
        app: '{{appConfig.name}} is part of the Compassion family.',
        general:
          'Compassion lets you seamlessly log in to services and experiences across the Compassion family, including Compassion.com, Compassion Causes, Donor Drive, and more.',
      },
    },
  },
  account: {
    welcomeBack: 'Welcome back, {{- name}}!',
    notYou: '(Not you?)',
  },
  skippy: {
    home: 'Home',
    aboutCompassionTitle: 'About Compassion International',
    aboutCompassionBody:
      'Compassion International is a Christian ministry dedicated to releasing children from poverty in Jesus’ name. In partnership with thousands of churches in 29 countries (and counting) around the world, we care for children with the love of Jesus, empowering them to overcome poverty through child sponsorship and other cause-based initiatives.',
    pressCenter: 'Press Center',
    child: {
      waiting: 'Waiting {{numDays}} days',
    },
    donation: {
      amount_OneTime: '{{amount, currency-custom}}',
      amount_Monthly: '{{amount, currency-custom}}/mo',
      amount_Annually: '{{amount, currency-custom}}/yr',
      donateAmount_OneTime: 'Donate {{amount, currency-custom}}',
      donateAmount_Monthly: 'Donate {{amount, currency-custom}}/mo',
      donateAmount_Annually: 'Donate {{amount, currency-custom}}/yr',
      frequency_OneTime: 'One-Time',
      frequency_Monthly: 'Monthly',
      frequency_Annually: 'Annually',
      other: 'Other',
      other_OneTime: 'Other (One-Time)',
      other_Monthly: 'Other (Monthly)',
      other_Annually: 'Other (Annually)',
      addToBasket: 'Add to Basket',
      enterAnAmount: 'Enter an Amount',
      enterCustomAmount: 'Enter Custom Amount',
      giftShare: 'Gift Share',
      popular: 'Popular',
      suggestedGift: 'Suggested Gift: {{amount, currency-custom}}',
      errors: {
        belowMinimum:
          'Donation amount must be at least {{min, currency-custom}}',
        aboveMaximum: 'Donation amount cannot exceed {{max, currency-custom}}',
        wouldExceedCartLimit:
          'Adding this amount would exceed the cart limit of {{max, currency-custom}}. Maximum you can add is {{remaining, currency-custom}}',
        cartLimitExceeded:
          'Cart has already reached the maximum limit of {{max, currency-custom}}',
        addToCartFailed: 'Unable to add donation to cart. Please try again.',
        cartAtLimit:
          'Cart has reached the maximum limit of {{max, currency-custom}}',
      },
    },
    sac: {
      viewMoreChildren: 'View More Children',
      helpFindMatch: 'Help Me Find a Match',
      betweenTheAges: 'Between the ages of',
      birthdaySearch: 'Search by birthday',
      wantToSponsor: 'I want to sponsor a',
      whoLivesIn: 'Who lives in',
      advancedSearch: 'Advanced Search',
      age_one: '{{birthday}} • {{count}} yr old',
      age_other: '{{birthday}} • {{count}} yrs old',
      resetTitle: 'Sorry, no children match your search criteria.',
      resetMessage: 'Try removing a preference or two!',
      resetFilters: 'Reset Filters',
      selectAChildForMe: 'Select A Child For Me',
      all: 'All',
      orphanedChild: 'Orphaned Child',
      hasDisabilities: 'Has Disabilities',
      vulnerableToExploitation: 'Vulnerable to Exploitation',
      affectedByHiv: 'Affected by HIV/AIDS',
      thisChild: 'this child',
      useSearchControls:
        'Thank you for exploring so many children that need sponsorship. Use the filters above to find children by age, birthday, region, or other criteria that matter to you.',
      controls: {
        legend: 'Who would you like to sponsor?',
        boy: 'Boy',
        girl: 'Girl',
        either: 'Either',
        chooseGender: 'Choose a gender',
        allCountries: 'All Countries',
        multipleCountries: 'Multiple Countries',
        month: 'Month',
        day: 'Day',
      },
      bio: 'Unsponsored Child Bio',
    },
    tabGroup: {
      defaultAriaLabel: 'Tab Options',
    },
    article: {
      intro: 'TLDR;',
      conclusion: 'Conclusion',
      pagination: {
        next: 'Next',
        previous: 'Previous',
      },
      sort: { featured: 'Featured', newest: 'Newest', oldest: 'Oldest' },
      search: 'Search',
      searchContentHub: 'Search the content hub',
      searchPlaceholder: 'Search for an article title, tag, location, etc.',
      subscribeTitle: 'Join over 950,000 subscribers!',
      contributors: 'Contributors',
      updates: 'Updates',
      tableOfContents: 'Table of Contents',
      resultWithCount_one: '{{count}} Result',
      resultWithCount_other: '{{count}} Results',
      noResultsTitle: 'Uh oh!',
      noResultsBody:
        "<1>It looks like there aren't any stories or blog posts with that tag right now.</1><1>You can <2>go back to our full list of tags</2> or try <3>searching for it</3>  instead.</1>",
      resultsWithPagination: 'Showing {{start}}-{{end}} of {{total}}',
      resultsWithPaginationQuery:
        'Showing {{start}}-{{end}} of {{total}} for <1>"{{query}}"</1>',
      noResults: 'We couldn\'t find a match for "<1>{{query}}</1>"',
      writtenBy: 'Written By',
      publishedOn: 'Published On',
      relatedContent: 'Related Content',
      tags: 'Tags',
    },
    video: {
      play: 'Play',
      pause: 'Pause',
      watch: 'Watch Video',
    },
    socialMedia: {
      follow: 'Follow us on social media',
      facebook: 'Facebook',
      twitter: 'X (Twitter)',
      instagram: 'Instagram',
      tiktok: 'Tik Tok',
    },
    tabs: {
      all: 'View All',
      topic: 'By Topic',
      theme: 'By Theme',
      country: 'By Country',
      search: 'Search',
    },
    taxonomy: {
      tagged: 'Tagged',
      all: 'All Categories',
      cms: {
        intendedForReuse: 'Intended For Reuse',
        intentionallyOrphaned: 'Intentionally Orphaned',
      },
      articleThemes: {
        theme: { name: 'Theme' },
        alumni: {
          name: 'Alumni',
          seoTitle: 'Alumni Stories of Hope & Impact',
          seoDescription:
            'Discover inspiring stories of Compassion alumni who are making a difference after graduating from the program.',
        },
        childDevelopment: {
          name: 'Child Development',
          seoTitle: 'Child Development Impact Stories',
          seoDescription:
            'Learn how Compassion cares for children’s physical, mental, emotional and spiritual needs as they grow.',
        },
        christmas: {
          name: 'Christmas',
          seoTitle: 'Celebrate Christmas with Compassion',
          seoDescription:
            'Dive into the nativity story as told by Compassion children and learn about Christmas traditions in the countries we serve.',
        },
        church: {
          name: 'Church',
          seoTitle: 'Local Church Partners Transform Communities',
          seoDescription:
            'Did you know all our work is done through partnerships with local churches around the world? Explore why local churches are catalysts for change.',
        },
        community: {
          name: 'Community',
          seoTitle: 'Stories of Community Impact',
          seoDescription:
            'Discover how Compassion’s work to release children from poverty creates ripple effects in communities around the world.',
        },
        conflict: {
          name: 'Conflict',
          seoTitle: 'How Compassion Responds to Conflict',
          seoDescription:
            'Explore how Compassion supports children and families during conflict and crises in the countries they serve.',
        },
        culture: {
          name: 'Culture',
          seoTitle: 'Culture & Traditions Around the World',
          seoDescription:
            'Explore the diverse countries we serve through traditions, recipes and stories from children at Compassion centers.',
        },
        disaster: {
          name: 'Disaster',
          seoTitle: 'Disaster Response & Recovery',
          seoDescription:
            'Learn how Compassion responds to disasters like earthquakes and floods to support vulnerable communities around the world.',
        },
        discipleship: {
          name: 'Discipleship',
          seoTitle: 'Discipleship & Scriptural Resources',
          seoDescription:
            'Because Jesus is our core, it’s central to our mission to be led by God’s Word. Explore curated resources centered on discipleship here.',
        },
        easter: {
          name: 'Easter',
          seoTitle: 'Celebrate Easter with Compassion',
          seoDescription:
            'Dive into the story of Christ’s resurrection and learn how Easter is celebrated in the countries we serve.',
        },
        economicDevelopment: {
          name: 'Economic Development',
          seoTitle: 'Experience the Impact of Economic Development',
          seoDescription:
            'See how vocational training and income generation programs help families and children break the cycle of poverty.',
        },
        education: {
          name: 'Education',
          seoTitle: 'See How Access to Education is Changing Lives',
          seoDescription:
            'Education empowers children to break the cycle of poverty — but many families can’t afford it. Learn how poverty affects education and how Compassion is helping.',
        },
        family: {
          name: 'Family',
          seoTitle: 'Impactful Stories About Family',
          seoDescription:
            'Read inspiring stories about the families being impacted by Compassion’s work in communities around the world.',
        },
        health: {
          name: 'Health',
          seoTitle: 'Health & Medical Care for Children ',
          seoDescription:
            'Explore how Compassion provides critical medical care, disability support, life-saving surgeries and regular medical check-ups in these impactful stories.',
        },
        humanRights: {
          name: 'Human Rights',
          seoTitle: 'Human Rights & Child Advocacy ',
          seoDescription:
            'As child advocates, learn how Compassion addresses the injustices of poverty in the countries we serve.',
        },
        letters: {
          name: 'Letters',
          seoTitle: 'Letter Writing Resources for Sponsors',
          seoDescription:
            'Discover how writing letters builds connection, deepens relationships and inspires children around the world.',
        },
        mentalHealth: {
          name: 'Mental Health',
          seoTitle: 'Stories on Mental Health',
          seoDescription:
            'Explore how Compassion addresses the mental health challenges children living in poverty experience.',
        },
        nutrition: {
          name: 'Nutrition',
          seoTitle: 'Nutrition & Hunger Solutions',
          seoDescription:
            'Learn how Compassion tackles malnutrition through food programs and interventions.',
        },
        prayer: {
          name: 'Prayer',
          seoTitle: 'Daily Prayers & Prayer Guides',
          seoDescription:
            'Find prayers for children, families and global issues aligned with Compassion’s mission.',
        },
        recipes: {
          name: 'Recipes',
          seoTitle: 'Recipes from Around the World',
          seoDescription:
            'Discover traditional recipes from the countries we serve and learn more about their cultural significance.',
        },
        sanitationAndHygiene: {
          name: 'Sanitation and Hygiene',
          seoTitle: 'Sanitation & Hygiene Care in Vulnerable Communities',
          seoDescription:
            'Discover how sanitation programs improve health and dignity in vulnerable communities around the world.',
        },
        survival: {
          name: 'Survival',
          seoTitle: 'Helping Moms & Babies Thrive',
          seoDescription:
            'Discover how Compassion’s Survival program supports vulnerable mothers and babies with medical care, nutrition, spiritual guidance and more.',
        },
        water: {
          name: 'Water',
          seoTitle: 'Clean Water Access & Impact',
          seoDescription:
            'Explore how Compassion addresses water scarcity and provides clean water solutions with the support of our sponsors.',
        },
        worldDays: {
          name: 'World Days',
          seoTitle: 'Global Awareness Days',
          seoDescription:
            'Discover global awareness days that align with Compassion’s mission, like World Poverty Day and more.',
        },
      },
      articleTopics: {
        aboutCompassion: {
          name: 'About Compassion',
          seoTitle: 'About Compassion: Our Mission & Work',
          seoDescription:
            'Learn about Compassion’s mission, values and approach to releasing children from poverty in Jesus’ name.',
        },
        childSponsorship: {
          name: 'Child Sponsorship',
          seoTitle: 'Child Sponsorship: What it Provides & Why it Matters',
          seoDescription:
            'Learn how child sponsorship changes lives. Discover the basics of child sponsorship, what it provides and how it empowers children to thrive.',
        },
        christianFaith: {
          name: 'Christian Faith',
          seoTitle: 'Christian Faith: Prayer, Devotionals & More',
          seoDescription:
            'Find inspiration through devotionals, Bible verses about topics on your heart and stories of faith. Explore how Christian values guide our mission.',
        },
        forSponsors: {
          name: 'For Sponsors',
          seoTitle: 'Resources & Inspiring Stories For Sponsors',
          seoDescription:
            'Deepen your impact with how-to guides, inspiring stories and additional ways to give and connect with the child you sponsor.',
        },
        impact: {
          name: 'Impact',
          seoTitle: 'Impact Stories: See the Compassion Difference',
          seoDescription:
            'Discover how lives are being transformed through Compassion. Read real stories and explore data that shows the impact of your support.',
        },
        poverty: {
          name: 'Poverty',
          seoTitle: 'Understanding Poverty: Causes & Impact',
          seoDescription:
            'Explore articles that dive into the realities of poverty — its causes, impact on children and families, and stories that bring the issue to life.',
        },
        topic: {
          name: 'Topic',
        },
      },
      articleTypes: {
        article: {
          singularName: 'Article',
          pluralName: 'Articles',
          seoTitle: 'Articles',
          seoDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        },
        blogPost: {
          singularName: 'Blog Post',
          pluralName: 'Blog Posts',
          seoTitle: 'Stories & Blog',
          seoDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        },
        crisisUpdate: {
          singularName: 'Crisis Update',
          pluralName: 'Crisis Updates',
          seoTitle: 'Crisis Updates',
          seoDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        },
        pressRelease: {
          singularName: 'Press Release',
          pluralName: 'Press Releases',
          seoTitle: 'Press Releases',
          seoDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        },
        type: {
          singularName: 'Article',
        },
      },
      fundCategories: {
        basicNeeds: 'Basic Needs',
        communityCareAndDevelopment: 'Community Care & Development',
        educationAndClasses: 'Education & Classes',
        emergencySupport: 'Emergency Support',
        food: 'Food',
        healthAndMedical: 'Health & Medical',
        homeAndShelter: 'Home & Shelter',
        jobsAndIncome: 'Jobs & Income',
        livestockAndAgriculture: 'Livestock & Agriculture',
        moms: 'Moms, Babies, Childcare',
        relief: 'Relief',
        technology: 'Technology',
      },
      fundPromotions: {
        giftCatalog: 'Gift Catalog',
        mostNeeded: 'Most Needed',
        popular: 'Popular',
        urgent: 'Urgent',
      },
      personalizationSegments: {
        largeDonor: 'Large Donor',
        currentSponsor: 'Current Sponsor',
      },
      other: {
        promotedContent: 'Promoted Content',
      },
    },
    siteSearch: {
      searchResults: 'Search Results',
      searchOurSite: 'Search our site',
      tabs: {
        all: 'All',
        pages: 'Pages',
        stories: 'Stories',
        pressReleases: 'Press Releases',
        accountHelp: 'Account Help',
      },
      types: {
        article: 'Article',
        blogPost: 'Blog Post',
        pressRelease: 'Press Release',
        crisisUpdate: 'Crisis Update',
        page: 'Page',
      },
      error:
        "We're sorry, something went wrong with your search. Please try again or contact us if the problem persists.",
    },
    footer: {
      copyright: `© ${new Date().getFullYear()} Compassion International. All Rights Reserved.`,
      nonProfit:
        'Compassion International, Inc. is a registered 501(c)(3) nonprofit organization.',
      taxNumber: 'Tax ID (EIN) 36-2423707',
      trademarks:
        'Compassion®, Compassion International®, Compassion Sunday®, the Compassion Logo and the FILL THE STADIUM Logo are registered trademarks of Compassion International, Inc.',
    },
    form: {
      contactFields: {
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        roleLabel: 'Role',
      },
      churchFields: {
        churchNameLabel: 'Church Name',
        churchSizeLabel: 'Church Size',
        churchAddressLabel: 'Church Address',
        churchCityLabel: 'Church City',
        churchStateLabel: 'Church State',
        churchPostalLabel: 'Church Zip',
      },
      addressFields: {
        addressLabel: 'Address',
        cityLabel: 'City',
        stateLabel: 'State',
        statePlaceholder: 'Select state',
        zipCodeLabel: 'Zip Code',
      },
      emailSubscribe: {
        ariaLabel: 'Email Subscribe',
        title: 'Join Over 950,000 Subscribers!',
        description:
          'Stay up to date on how God is working through our ministry.',
        subscribe: 'Subscribe',
        thankYou: 'Thank you for subscribing!',
      },
      compassionSunday: {
        registrationAriaLabel: 'Compassion Sunday Event Registration',
        pastorLabel: 'I am a pastor at this church',
        pastorQuestionLabel: 'Are you a pastor?',
        childLabel:
          'I am planning on hosting this Compassion Sunday event with a kid',
        childQuestionLabel: 'Are you hosting with a child?',
        permissionLabel: 'Do you have permission to host this event?',
        permissionAnswerNo: "I'm not sure. I could use some help!",
        contactHeader: 'Contact Info',
        shippingHeader: 'Shipping Info',
        tShirtHeader: 'T-Shirt',
        eventHeader: 'Event Info',
        tShirtSizeLabel: 'T-Shirt Size',
        tShirtSizeKidsLabel: `Child's T-Shirt Size`,
        tShirtSizeCoHostLabel: 'Co-Host T-Shirt Size',
        churchInfoDisclaimer:
          "Sharing some contact info for your church allows us to better support you as you host your event. We won't use this information to send you unwanted mail.",
        eventDateLabel: 'Event Date',
        churchNameLabel: 'Church Name',
        churchAddressLabel: 'Church Address',
        audienceSize: {
          label: 'Audience Size',
          helpText:
            "Choose the expected audience size for your event. This doesn't have to be perfect — just your best estimate. This will help us determine how many child packets to send you.",
          placeholder: 'Select an option',
        },
        acknowledgeLabel: 'I acknowledge I am 18 years of age or older',
        register: 'Register Event',
        helpInfoTitle:
          'Do you need help coordinating the details with your church?',
        helpInfoText:
          'If you need help connecting with your church leadership, you can find <0 href="/compassionsunday/pastor-permission-resources.htm">helpful resources and tips here</0>.',
        identifierInfo:
          'Some hosts are pastors of their church or choose to host with a child. If either of these apply to you, please check the corresponding box below.',
        planningSubmit: 'Yes, please send me my planning guide',
        tShirtSize: {
          placeholder: 'Select a size',
          adultSm: 'Adult T-Shirts - Small Unisex',
          adultMd: 'Adult T-Shirts - Medium Unisex',
          adultLg: 'Adult T-Shirts - Large Unisex',
          adultXL: 'Adult T-Shirts - XLarge Unisex',
          adultXXL: 'Adult T-Shirts - XXLarge Unisex',
          adult3XL: 'Adult T-Shirts - 3XLarge Unisex',
          adult4XL: 'Adult T-Shirts - 4XLarge Unisex',
          youthSm: 'Youth T-Shirts - (Small)',
          youthMd: 'Youth T-Shirts - (Medium)',
          youthLg: 'Youth T-Shirts - (Large)',
          youthXL: 'Youth T-Shirts - (XL)',
          none: 'None',
        },
        errorText: 'There was an error processing your request.',
        successText: 'Your request was submitted.',
      },
      errorSave:
        'We were unable to save your information. Please try again later.',
      errorVerify: 'Please verify your information.',
      leadCreate: {
        buttonText: 'Contact Me',
        thankYou: 'Thank you for your interest in Compassion International.',
      },
      roleOptions: {
        defaultText: 'Select a role',
        pastor: 'Pastor',
        churchStaff: 'Church Staff',
        congregant: 'Member/Congregant',
      },
      sizeOptions: { defaultText: 'Select an option' },
      stateOptions: { defaultText: 'Select state' },
    },
    reviews: {
      sponsor_new: 'A new sponsor',
      sponsor_oneYear: 'A sponsor of over a year',
      sponsor_tenYear: 'A sponsor of over 10 years',
      sponsor_twentyFiveYear: 'A sponsor of over 25 years',
      sponsor_na: 'A friend of Compassion',
      from: ' from {{place}}',
      description: '{{time}} {{where}}',
      recommend: 'Yes, I would recommend Compassion to a friend',
    },
  },
  compex: {
    footer: {
      copyright: '© 2024 Compassion International. All Rights Reserved.',
      nonProfit:
        'Compassion International, Inc. is a registered 501(c)(3) nonprofit organization.',
      taxNumber: 'Tax ID (EIN) 36-2423707',
      trademarks:
        'Compassion®, Compassion International®, Compassion Sunday®, the Compassion Logo and the FILL THE STADIUM Logo are registered trademarks of Compassion International, Inc.',
    },
  },
  giftCatalog: {
    filterBy: 'Filter By ({{count}})',
    filterByWithoutCount: 'Filter By',
    loading: 'Loading gifts...',
    loadMore: 'Load More',
    showingGifts: 'Showing {{count}} of {{countAllGifts}} items',
    category: 'Category',
    viewAllGifts: 'View All Gifts',
    subHeading: 'Gifts that can change a life or a community',
    sortBy: 'Sort By',
    remove: 'Remove {{name}}',
    priceRange: 'Price Range',
    clearAll: 'Clear All',
    error:
      "We're sorry, something went wrong with your search. Please try again or contact us if the problem persists.",
    sort: {
      mostNeeded: 'Most Needed',
      priceLowToHigh: 'Price (Low to High)',
      priceHighToLow: 'Price (High to Low)',
      alphabeticalAZ: 'Alphabetical (A to Z)',
      alphabeticalZA: 'Alphabetical (Z to A)',
    },
  },
};
